import styled from "styled-components";
import { Breakpoint } from "../../hooks/useBreakpoint/useBreakpoint.types.js";
import { ContainerProps, DefaultContainerProps } from "./Container.types.js";

export const StyledContainer = styled.div<DefaultContainerProps & Omit<ContainerProps, "children">>`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    border-top-left-radius: ${(props) => props.theme.radius["3xl"]};
    border-bottom-left-radius: ${(props) => props.theme.radius["3xl"]};
    padding: ${(props) => (props.fluid ? 0 : `${props.theme.spacing[24]}`)};
    position: relative;
    @media (min-height: ${(props) => props.theme.breakpoints[Breakpoint.MD]}) {
        padding: ${(props) => (props.fluid ? 0 : `${props.theme.spacing[48]}`)};
    }
`;
